/* MXDVS product card, 28.09.2026
   Shared by the homepage and, next, the collection pages.
   - Product names decode on hover (desktop only).
   - The sale percentage decodes once, the first time it scrolls into view.
   - Inside a list with data-mx-fade, products fade in as they scroll into view.
   - Names stay on one line. Too long: phones scroll them sideways once when the card comes into view, desktop on hover (08.10.2026).
   New cards (theme editor reloads, infinite scroll) are picked up automatically.
   Loaded by several sections; the guard below makes sure it only runs once.
   05.10.2026: new cards are found without rescanning the page on every text change (smoother scrolling on phones).
   09.10.2026: a decoding name keeps its exact width and only uses narrow letters, so it never breaks onto a second line. */
(function () {
  if (window.MxCard) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;
  /* 09.10.2026: only letters and digits that are no wider than the real letters (no W, M, Q or symbols),
     so a decoding name never gets wider than its line */
  var GLYPHS = 'ABCDEFGHIJKLNOPRSTUVXYZ0123456789';

  /* Decode: every letter scrambles, then settles from left to right.
     09.10.2026: the element keeps its exact width while it decodes (before: only a minimum width) */
  function decode(el, text, ms) {
    cancelAnimationFrame(el._mxRaf);
    if (reduce) {
      el.textContent = text;
      return;
    }
    if (!el._mxDecoding) el.style.width = el.offsetWidth + 'px';
    el._mxDecoding = true;
    var start = performance.now();
    var last = 0;
    function frame(now) {
      var t = now - start;
      if (t >= ms) {
        el.textContent = text;
        el.style.width = '';
        el._mxDecoding = false;
        return;
      }
      if (now - last > 45) {
        last = now;
        var out = '';
        for (var i = 0; i < text.length; i++) {
          var c = text.charAt(i);
          var settleAt = ms * 0.4 + (i / text.length) * ms * 0.6;
          out += (c === ' ' || t >= settleAt) ? c : GLYPHS.charAt(Math.floor(Math.random() * GLYPHS.length));
        }
        el.textContent = out;
      }
      el._mxRaf = requestAnimationFrame(frame);
    }
    el._mxRaf = requestAnimationFrame(frame);
  }

  /* Product names: decode on hover */
  document.addEventListener('mouseover', function (e) {
    if (!canHover) return;
    var card = e.target.closest ? e.target.closest('.mx-card') : null;
    if (!card || card.contains(e.relatedTarget)) return;
    var name = card.querySelector('[data-decode]');
    if (name) {
      /* a name that is cut off scrolls once to show the rest (08.10.2026) */
      var box = name.parentElement;
      if (box && box.classList.contains('mx-card__name')) { measure(box); tick(box); }
      decode(name, name.getAttribute('data-decode'), 450);
    }
  });

  var hasIo = 'IntersectionObserver' in window;

  /* Sale percentage: decode once when it scrolls into view */
  var saleIo = hasIo ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      saleIo.unobserve(el);
      setTimeout(function () {
        decode(el, el.getAttribute('data-decode-in'), 700);
      }, 150);
    });
  }, { threshold: 1 }) : null;

  /* Fade-in: items that enter together get a small delay between them */
  var batch = 0;
  var batchTimer = null;
  var fadeIo = hasIo ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var list = el.closest('[data-mx-fade]');
      var stagger = list ? parseInt(list.getAttribute('data-mx-fade'), 10) || 90 : 90;
      el.style.setProperty('--mx-delay', (batch++ * stagger) + 'ms');
      el.classList.add('is-in');
      fadeIo.unobserve(el);
    });
    clearTimeout(batchTimer);
    batchTimer = setTimeout(function () { batch = 0; }, 200);
  }, { threshold: 0.2 }) : null;

  /* Phones: long name ticker. Only names that don't fit get the fade and the scroll. */
  var phone = window.matchMedia('(max-width: 989px)');
  function measure(name) {
    var inner = name.firstElementChild;
    if (!inner) {
      name.classList.remove('is-long');
      name._mxExtra = 0;
      return;
    }
    var extra = inner.scrollWidth - name.clientWidth;
    name._mxExtra = extra > 1 ? extra : 0;
    name.classList.toggle('is-long', name._mxExtra > 0);
  }
  function tick(name) {
    if (reduce || !name._mxExtra || name._mxRunning) return;
    var inner = name.firstElementChild;
    var dur = getComputedStyle(inner).transitionDuration;
    var ms = (parseFloat(dur) || 2.4) * (dur.indexOf('ms') > -1 ? 1 : 1000);
    name._mxRunning = true;
    name.classList.add('is-running');
    inner.style.transform = 'translateX(' + (-name._mxExtra) + 'px)';
    setTimeout(function () {
      inner.style.transform = '';
      setTimeout(function () {
        name.classList.remove('is-running');
        name._mxRunning = false;
      }, ms);
    }, ms + 600);
  }
  var tickIo = hasIo ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var name = entry.target;
      measure(name);
      if (!name._mxExtra) return;
      tickIo.unobserve(name);
      setTimeout(function () { tick(name); }, 400);
    });
  }, { threshold: 1 }) : null;

  function scan(root) {
    root = root || document;

    root.querySelectorAll('.mx-card__name:not([data-mx-tick])').forEach(function (name) {
      name.setAttribute('data-mx-tick', '');
      if (tickIo && !reduce && phone.matches) tickIo.observe(name);
      else if (!phone.matches) measure(name);
    });

    root.querySelectorAll('[data-decode-in]:not([data-mx-seen])').forEach(function (el) {
      el.setAttribute('data-mx-seen', '');
      if (saleIo && !reduce) saleIo.observe(el);
    });

    root.querySelectorAll('[data-mx-fade] .mx-card:not([data-mx-seen])').forEach(function (card) {
      card.setAttribute('data-mx-seen', '');
      var item = card.parentElement;
      if (!item || !fadeIo || reduce) return;
      item.classList.add('mx-fade');
      fadeIo.observe(item);
    });
  }

  /* Pick up cards added later: theme editor reloads and infinite scroll */
  var pending = false;
  function scheduleScan() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      scan(document);
    });
  }
  /* 05.10.2026: only when an element with a card (or a part of one) is added. Text that changes
     (the news pill typing, counters, decodes) no longer makes the whole page scan again. */
  var CARD_PARTS = '.mx-card, .mx-card__name, [data-decode-in]';
  function addsCards(records) {
    for (var r = 0; r < records.length; r++) {
      var added = records[r].addedNodes;
      for (var i = 0; i < added.length; i++) {
        var node = added[i];
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches(CARD_PARTS)) || (node.querySelector && node.querySelector(CARD_PARTS))) return true;
      }
    }
    return false;
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      if (addsCards(records)) scheduleScan();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', scheduleScan);
  window.addEventListener('load', function () {
    document.querySelectorAll('.mx-card__name').forEach(measure);
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('.mx-card__name').forEach(measure);
  });

  window.MxCard = { decode: decode, scan: scan };
})();